<script>
    import Modal from './Modal.svelte';
    import Fa from 'svelte-fa';
    import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/';
    import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/';
    import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/';
    import { faTimes } from '@fortawesome/free-solid-svg-icons/';

    const icons = [
        { type: "success", icon: faCheckCircle, color: "#5dbc66" },
        { type: "info", icon: faInfoCircle, color: "#2e72df"  },
        { type: "warning", icon: faExclamationCircle, color: "#e59225" },
        { type: "error", icon: faExclamationCircle, color: "#de4c34" }
    ];

    $: usedIcon = icons.find(x => x.type === icon);

    export let visible = false;
    export let icon = "info";
    export let message = "";

    export function show(type, msg) {
        icon = type;
        message = msg;
        visible = true;
    }
</script>

<Modal bind:visible>
    <div class="container">
        {#if usedIcon}
            <Fa bind:icon={usedIcon.icon} bind:color={usedIcon.color} size="2x" />
        {/if}
        <div class="message">{message}</div>
        <div class="closeButton" on:click={() => visible = false}>
            <Fa icon={faTimes} color="#333" />
        </div>
    </div>
</Modal>

<style>
    .container {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;
    }

    .message {
        grid-column-start: 2;
        max-width: 300px;
        margin-right: 30px;
    }

    .closeButton {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
    }

    .closeButton:hover {
        background-color: #ccc;
    }
</style>